module.exports = __webpack_public_path__ + "static/img/IQ.4eae31eb.svg";